export default __webpack_public_path__ + "static/media/Hunain_Shah.60717b7c.png";